import {Moment} from 'moment';

export enum WidgetType {
  REP_SCORECARDS = 'REP_SCORECARDS',
  TEAM_SCORECARDS = 'TEAM_SCORECARDS',
}
enum WidgetId {
  SW_REP_DASH = 'strengths_and_weakness_rep_dashv2',
}

enum ScoresOption {
  MY_SCORES = 'MY_SCORES',
  REP_SELF_SCORES = 'REP_SELF_SCORES',
  TEAM_SCORES = 'TEAM_SCORES',
  ALL_SCORES = 'ALL_SCORES',
}

// todo move me
type ScorecardId = string;
// todo move me
type CallStageId = string;

export interface WidgetConfig {
  widgetId: WidgetId;
  widgetType: WidgetType;
  startDate: Moment;
  endDate: Moment;
  scorecard: ScorecardId | 'ALL';
  callStage: CallStageId | 'ALL';
  scoresOption: ScoresOption;
}
